"use client";

import { Box, Button, Container, Stack, Typography } from "@mui/material";
import type { NextPage } from "next";
import Head from "next/head";
import React from "react";

export const Whitepaper: NextPage = () => {
  const ogImage = "/static/images/Meta1.jpg";

  const title = "PROM | Bridging EVM & Non-EVM worlds";

  const prefix = "";
  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.png" />
        <meta
          property="og:site_name"
          content="Prom"
          data-shuvi-head="true"
          key="og:site_name"
        />
        <meta
          property="twitter:site"
          content="Prom"
          data-shuvi-head="true"
          key="twitter:site"
        />
        <meta
          name="twitter:description"
          content="Modular zkEVM Layer 2 that enables interoperability across various chains. Prom submits its proof of transaction to more chains on top of the chosen Settlement chain, building the bridge between ecosystems."
        />

        <React.Fragment>
          <title>
            {prefix}
            {title}
          </title>
          <meta
            property="og:title"
            content={`${prefix}${title}`}
            key="og_title"
          />
          <meta
            name="twitter:title"
            content={`${prefix}${title}`}
            key="twitter_title"
          />
        </React.Fragment>

        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitter:card"
        />
        <meta property="og:image" content={ogImage} key="og:image" />
        <meta name="twitter:image" content={ogImage} key="twitter:image" />
      </Head>
      <Container
        sx={{
          minHeight: "65vh",
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            right: { xs: "50%", md: "unset" },
            left: { xs: "50%", md: "unset" },
            width: { xs: "100vw", md: "100vw" },
            marginLeft: { xs: "-50vw", md: "unset" },
            marginRight: { xs: "-50vw", md: "unset" },
          }}
        >
          <Stack
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: { xs: 0, md: "40px" },
              zIndex: -1,
            }}
          >
            <img alt="img" src="/static/images/gradient-bg.svg" />
          </Stack>

          <Stack
            py={10}
            px={5}
            spacing={3}
            alignItems="center"
            maxWidth={600}
            margin="0 auto"
          >
            <Typography variant="h1" textAlign="center">
              Our Marketplace Whitepaper
            </Typography>

            <Typography
              variant="highlight"
              color="text.secondary"
              textAlign="center"
              maxWidth={(theme) => theme.breakpoints.values.sm}
            >
              Want to get know us better? Explore our Whitepaper!
            </Typography>

            <Box textAlign="center">
              <Button
                component="a"
                variant="contained"
                sx={{ px: 33, py: 3, mt: 7 }}
                href="/static/whitepaper.pdf"
                download
              >
                Get Whitepaper
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
    </>
  );
};
